module.exports = __webpack_public_path__ + "img/search_files.3237678e.svg";